import { gsap } from 'gsap';
import flipbutton from '../snippets/flipbutton'

export default class NotFound {
    constructor(container) {
        this.container = container;
        this.flipbuttons = this.container.querySelectorAll('.not-found__container .js-flipbutton');
        this.init();
    }

    init = () => {

        gsap.fromTo(
            ['.not-found__display', '.not-found__digit', '.not-found__message', '.not-found__button'],
            { opacity: 0, y: 20 },
            { opacity: 1, y: 0, duration: 0.6, stagger: { each: 0.15 }, ease: 'power2.out', delay: 0.7 }
        );

        gsap.fromTo(this.container.querySelector('.not-found__circle'), { scale: 0.75, transformOrigin: '50% 50%' }, { scale: 1.05, duration: 1, stagger: { each: 0.2 }, repeat: -1, yoyo: true, transformOrigin: '50% 50%', ease: 'power1.inOut', delay: 0.2 });
        gsap.fromTo(this.container.querySelector('.not-found__inner'), { scale: 0.75, transformOrigin: '50% 50%' }, { scale: 1.05, duration: 1, stagger: { each: 0.2 }, repeat: -1, yoyo: true, transformOrigin: '50% 50%', ease: 'power1.inOut' });

        gsap.fromTo(this.container.querySelector('.not-found__error'), { scale: 1.25, transformOrigin: '50% 50%' }, { scale: 1.05, duration: 1, stagger: { each: 0.2 }, repeat: -1, yoyo: true, transformOrigin: '50% 50%', ease: 'power1.inOut' });

        this.flipbuttons.forEach(element => {
            new flipbutton(element, { left: 'initial' });
        });
    }
}
